import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useQuery } from 'urql'
import { useTranslation } from 'react-i18next'
import SelectInput from './SelectInput'
import FiltersIcon from './icons/filters'
import Button from './Button'
import { GetWarehouses } from '../graphql/queries'

const initialState = {
    warehouse: null,
    spot: null,
    protein: null,
}

const LabFilters = ({
    onFilterChange,
}) => {

    const { t } = useTranslation()
    const [filters, setFilters] = useState(initialState)
    const [warehouses, setWarehouses] = useState([])
    const [filtersOpened, setFiltersOpened] = useState(false)
    const [warehouseQuery] = useQuery({
        query: GetWarehouses,
        variables: {
            page: 0,
            limit: 100,
            orderBy: 'name',
        },
    })

    useEffect(() => {
        if (warehouseQuery.fetching) return

        setWarehouses(warehouseQuery?.data?.getWarehouses ?? [])
    }, [warehouseQuery?.fetching])

    useEffect(() => {
        if (onFilterChange) onFilterChange(filters)
    }, [])

    const setField = (field, value) => {
        const newVal = {
            ...filters,
            [field]: value,
        }

        if (field === 'warehouse') {
            newVal.spot = null
        }

        setFilters(newVal)

        if (onFilterChange) onFilterChange(newVal)
    }

    return (
        <div
            className={`filters-wrapper${filtersOpened ? ' filters--open' : ''}`}
        >
            <Button
                className='btn-filters'
                icon={<FiltersIcon fill={'#fff'} />}
                label={filtersOpened ? t('filters.filter_close') : t('filters.filter')}
                onClick={() => setFiltersOpened(!filtersOpened)}
            />
            <div className='filters'>
                <div className='filters-warehouse'>
                    <SelectInput
                        label={ t('lab.warehouse') }
                        options={warehouses}
                        value={warehouses.find(x => x.id === filters.warehouse)}
                        getOptionLabel={(option) => t(option.name)}
                        getOptionValue={(option) => option.id}
                        onChange={(option) => setField('warehouse', option.id)}
                    />
                    {
                        filters.warehouse ?
                        <SelectInput
                            label={ t('lab.warehouse_spot') }
                            options={warehouses.find(x => x.id === filters.warehouse).spots}
                            value={filters.spot ? warehouses.find(x => x.id === filters.warehouse).spots.find(x => x.id === filters.spot) : null}
                            getOptionLabel={(option) => t(option.name)}
                            getOptionValue={(option) => option.id}
                            onChange={(option) => setField('spot', option.id)}
                        />
                        :
                        <></>
                    }
                </div>
            </div>
        </div>
    )
}

LabFilters.propTypes = {
    onFilterChange: PropTypes.func,
}

export default LabFilters